import { useEffect } from 'react'

import moment from 'moment'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { ContractVersionsPayrollPolicies } from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import { Employees } from 'modules/employees/store/collections/employees'
import filterActiveEmployeesByPolicy from 'modules/payroll_bundle/lib/filterActiveEmployeesByPolicy'
import { Policies } from 'modules/payroll_bundle/store/collections/policies'

export const useGetPolicyActiveEmployees = (
  policyId: string,
  contractVersions: ContractVersions
) => {
  const policies = useLazyRef(() => new Policies()).current
  const contractVersionsPayrollPolicies = useLazyRef(
    () => new ContractVersionsPayrollPolicies()
  ).current
  const employees = useLazyRef(() => new Employees()).current
  const policy = policies.get(policyId)
  const today = moment()

  const { running, performAction } = useAsyncAction(
    (policyId: string) =>
      Promise.all([
        policies.fetch({ data: { ids: [policyId] } }),
        contractVersionsPayrollPolicies.fetch(),
        employees.fetch(),
      ]),
    { successFlash: false }
  )

  useEffect(() => {
    performAction(policyId)
  }, [policyId])

  return {
    fetching: running,
    employees,
    policy,
    policyActiveEmployees:
      !running && policy !== undefined
        ? filterActiveEmployeesByPolicy({
            employees,
            policy,
            contractVersions,
            contractVersionsPayrollPolicies,
            period: {
              startsOn: today,
              endsOn: today,
            },
          })
        : [],
    refetch: () => performAction(policyId),
  }
}
